import { render, staticRenderFns } from "./NewMessengerConversationDetailsItem.vue?vue&type=template&id=32e16a99&scoped=true"
import script from "./NewMessengerConversationDetailsItem.vue?vue&type=script&lang=js"
export * from "./NewMessengerConversationDetailsItem.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerConversationDetailsItem.vue?vue&type=style&index=0&id=32e16a99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e16a99",
  null
  
)

export default component.exports